"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRedux = require("react-redux");
var _selector = require("../selectors/selector");
var _Actions = require("../actions/Actions");
var _jsonpathPlus = require("jsonpath-plus");
var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _OfferCard = _interopRequireDefault(require("./OfferCard"));
var _Loading = _interopRequireDefault(require("./blocks/Loading"));
var _Header = _interopRequireDefault(require("./blocks/Header"));
var _ErrorComponent = _interopRequireDefault(require("./ErrorComponent"));
var _helpers = require("../helpers");
var _NotAvailableOffers = _interopRequireDefault(require("./NotAvailableOffers"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var WidgetContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: ", ";\n"])), function (props) {
  var _props$maxWidth;
  return (_props$maxWidth = props.maxWidth) !== null && _props$maxWidth !== void 0 ? _props$maxWidth : 'inherit';
});
function App() {
  var _useSelector;
  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(_selector.getLoadingState);
  var error = (0, _reactRedux.useSelector)(_selector.getError);
  var _useProps = (0, _useProps2.default)(),
    __instanceId = _useProps.__instanceId;
  var config = (0, _useConfig.default)();
  var _config$jsonPaths = config.jsonPaths,
    _config$jsonPaths2 = _config$jsonPaths === void 0 ? {} : _config$jsonPaths,
    _config$jsonPaths2$ms = _config$jsonPaths2.msisdnPath,
    msisdnPath = _config$jsonPaths2$ms === void 0 ? '' : _config$jsonPaths2$ms,
    _config$jsonPaths2$re = _config$jsonPaths2.recommendationGroupPath,
    recommendationGroupPath = _config$jsonPaths2$re === void 0 ? '' : _config$jsonPaths2$re,
    _config$jsonPaths2$ca = _config$jsonPaths2.catalogPriceValuePath,
    catalogPriceValuePath = _config$jsonPaths2$ca === void 0 ? '' : _config$jsonPaths2$ca,
    _config$jsonPaths2$im = _config$jsonPaths2.imageUrlPath,
    imageUrlPath = _config$jsonPaths2$im === void 0 ? '' : _config$jsonPaths2$im,
    _config$jsonPaths2$of = _config$jsonPaths2.offerIdPath,
    offerIdPath = _config$jsonPaths2$of === void 0 ? '' : _config$jsonPaths2$of,
    _config$jsonPaths2$pr = _config$jsonPaths2.priceUnitPath,
    priceUnitPath = _config$jsonPaths2$pr === void 0 ? '' : _config$jsonPaths2$pr,
    _config$jsonPaths2$pr2 = _config$jsonPaths2.priceValuePath,
    priceValuePath = _config$jsonPaths2$pr2 === void 0 ? '' : _config$jsonPaths2$pr2,
    _config$jsonPaths2$sh = _config$jsonPaths2.shortDescriptionPath,
    shortDescriptionPath = _config$jsonPaths2$sh === void 0 ? '' : _config$jsonPaths2$sh,
    _config$jsonPaths2$ti = _config$jsonPaths2.titlePath,
    titlePath = _config$jsonPaths2$ti === void 0 ? '' : _config$jsonPaths2$ti,
    _config$widgetCustomi = config.widgetCustomization,
    _config$widgetCustomi2 = _config$widgetCustomi === void 0 ? {} : _config$widgetCustomi,
    _config$widgetCustomi3 = _config$widgetCustomi2.maxWidth,
    maxWidth = _config$widgetCustomi3 === void 0 ? '' : _config$widgetCustomi3,
    _config$widgetCustomi4 = _config$widgetCustomi2.sliceNameWithMsisdn,
    sliceNameWithMsisdn = _config$widgetCustomi4 === void 0 ? '' : _config$widgetCustomi4;
  var otherStateSliceWithMsisdn = (_useSelector = (0, _reactRedux.useSelector)((0, _selector.getOtherWidgetSlice)(sliceNameWithMsisdn))) !== null && _useSelector !== void 0 ? _useSelector : {};
  var campaigns = (0, _reactRedux.useSelector)(_selector.getAllCampaigns);
  var Pre2KartJsonPaths = {
    catalogPriceValuePath: catalogPriceValuePath,
    imageUrlPath: imageUrlPath,
    offerIdPath: offerIdPath,
    priceUnitPath: priceUnitPath,
    priceValuePath: priceValuePath,
    shortDescriptionPath: shortDescriptionPath,
    titlePath: titlePath
  };
  var _JSONPath = (0, _jsonpathPlus.JSONPath)({
      path: msisdnPath,
      json: otherStateSliceWithMsisdn
    }),
    _JSONPath2 = _slicedToArray(_JSONPath, 1),
    selectedMsisdn = _JSONPath2[0];
  var getCampaignData = function getCampaignData() {
    if (selectedMsisdn) {
      dispatch((0, _Actions.getCampaigns)({
        selectedMsisdn: selectedMsisdn,
        recommendationGroupPath: recommendationGroupPath,
        Pre2KartJsonPaths: Pre2KartJsonPaths
      }));
    }
  };
  (0, _react.useEffect)(function () {
    dispatch((0, _Actions.setInstanceId)(__instanceId));
  }, [__instanceId]);
  (0, _react.useEffect)(function () {
    getCampaignData();
  }, [selectedMsisdn]);
  if (isLoading) return /*#__PURE__*/_react.default.createElement(WidgetContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_Loading.default, null));
  if (error) return /*#__PURE__*/_react.default.createElement(WidgetContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_Header.default, null), /*#__PURE__*/_react.default.createElement(_ErrorComponent.default, {
    buttonAction: getCampaignData
  }));
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-offers-widget"
  }, /*#__PURE__*/_react.default.createElement(WidgetContainer, {
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_Header.default, null), (0, _helpers.isArrayFieldValid)(campaigns) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, campaigns.map(function (campaign, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_OfferCard.default, {
      index: index,
      campaign: campaign,
      selectedMsisdn: selectedMsisdn
    }));
  })) : /*#__PURE__*/_react.default.createElement(_NotAvailableOffers.default, null)));
}